import React from "react";
import {
  List,
  Card,
  Dropdown,
  Image,
  Container,
  Header,
  Button,
} from "semantic-ui-react";
import { dispatch } from "@rematch/core/";
import noIntegrationToShow from "../../../../../images/common/no_integration_in_account.png";
import noINtegrationConfigured from "../../../../../images/common/noINtegrationConfigured.png";
export default class Integrations extends React.Component {
  viewPlans = () => {
    this.props.history.push({
      pathname: `/app/${this.props.selectedAccount._id}/upgrade`,
    });
  };

  render() {
    return !this.props.selectedAccount.planId.includes("enterprise") &&
      !this.props.selectedAccount.planId.includes("premium") ? (
      <Container fluid className="pad_40">
        <Image
          src={noIntegrationToShow}
          className="landingImage"
          size="large"
          centered={true}
          style={{ width: "400px", height: "300px" }}
        />
        <div className="text-center">
          <h1>Upgrade Subscription</h1>
          <p>You can upgrade your Subscription </p>
          <p>in order to use this feature.</p>
          <Button onClick={this.viewPlans} primary>
            Upgrade Plans
          </Button>
        </div>
      </Container>
    ) : (this.props.selectedAccount.planId.includes("enterprise") ||
        this.props.selectedAccount.planId.includes("premium")) &&
      this.props.integrationsList &&
      this.props.integrationsList.data &&
      this.props.integrationsList.data.length > 0 ? (
      <Card>
        <Card.Header>Integrations</Card.Header>
        <Card.Content className="pad_0">
          <List divided verticalAlign="middle">
            {this.props.integrationsList &&
            this.props.integrationsList.data.length > 0 &&
            this.props.selectedAccount
              ? this.props.integrationsList.data.map((integration) => {
                  return (
                    <List.Item className="singleLine">
                      {this.props.selectedAccount &&
                      this.props.selectedAccount.integrations &&
                      this.props.selectedAccount.integrations.some(
                        (el) =>
                          (el.id._id ? el.id._id : el.id) === integration._id &&
                          el.isActive
                      ) ? (
                        <List.Content floated="right" className="clr-blue">
                          Enabled
                        </List.Content>
                      ) : (
                        <List.Content floated="right">Disabled</List.Content>
                      )}

                      <List.Content>
                        <span>
                          <Image
                            avatar
                            src={integration.image}
                            className="w_24 h_24"
                          />
                          {integration.label} &nbsp;
                        </span>
                        {/* <List.Header>{integration.label}</List.Header> */}
                      </List.Content>
                    </List.Item>
                  );
                })
              : null}
          </List>
        </Card.Content>
      </Card>
    ) : (
      <Container fluid className="pad_40">
        <Image
          src={noINtegrationConfigured}
          className="landingImage"
          size="large"
          centered={true}
          style={{ width: "400px", height: "300px" }}
        />
        <div className="text-center">
          <h1 className="ff_b">No integrations configured currently</h1>
          {/* <Button onClick={this.viewPlans} primary>Upgrade Plans</Button> */}
        </div>
      </Container>
    );
  }
}
